import React, { useEffect, useState, useCallback } from 'react';
import { Button, Card, Col, Modal, Form, Input, Pagination, message, Row, Select, Space, Table } from 'antd';
import { usePageData } from '../../../hooks/usePage';
import { IPageData } from '../../../interfaces/page';
import { Divider } from 'antd';
import generalesProvider from '../../../services/generalesProvider';

const moment = require('moment');
const { Option } = Select;
const pageData: IPageData = {
  fulFilled: true,
  breadcrumbs: [
    {
      title: 'Administración de Lista Valores',
      route: 'administracion-listavalores'
    },
    {
      title: 'Lista Valores'
    }
  ]
};

interface Filtro {
  listaId: number,
  // pagenum: number,
  // pagesize: number,
}

const key = 'regitrando';
const pageSize = 5;
const PaginacionPersonalizada = ({ total, onChange, current }) => {
  return (
    <Pagination onChange={onChange} simple={true} total={total} current={current} pageSize={pageSize} />
  );
};
const AdministracionListaValores = () => {
  usePageData(pageData);
  const [titleListaValor, setTitleListaValor] = useState('');
  const [isModalListarValorVisible, setIsModalListarValorVisible] = useState(false);
  const [formModalListarValor] = Form.useForm();
  const [data, setData] = useState({ data: [], totalRecords: 0 });
  const [current, setCurrent] = useState(1);
  const [idLista, setIdLista] = useState(0);
  const [formFile] = Form.useForm();
  const [lista, setLista] = useState<any>([]);
  const [filtro, setfiltro] = useState<Filtro>({
    listaId: 0
  });
  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
      render: text => <a>{text}</a>,
      width: '85%'
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => {
        return (
          <Space size='middle'>
            <Button size='small' type='primary' onClick={(e) => btnEditarListaValor(text)}>Editar</Button>
            <Button size='small' type='primary' onClick={(e) => btnEliminarListaValor(text)} danger>Eliminar</Button>
          </Space>
        );
      },
      align: 'center' as 'center'
    }
  ];
  const onSubmitCrearFileOk = useCallback(async (values) => {
    var request = {
      id: values.getFieldValue('id') === undefined ? 0 : parseInt(values.getFieldValue('id')),
      descripcionvalor: values.getFieldValue('descripcionvalor'),
      skeycab: 'SKEYCATEGORIAGESTIONDOCUMENTO'
    };
    const res: any = await generalesProvider.Registrar_Actualizar_Categoria(request);
    if (res.succeeded) {
      message.success(res.message);
      listarCategoria();
      /*Reseteamos el formulario  */
      formFile.resetFields();
    } else {
      message.error('Ocurreo un error al intentar crear el archivo');
    }
  }, []);
  const listarCategoria = async () => {

    const paginacion = {
      pagenum: current,
      pagesize: pageSize,
      listaId: filtro.listaId
    };
    const res: any = await generalesProvider.listar_listavalorespaginado(paginacion);
    if (res.data) {
      setData(res);
    }
  };
  useEffect(() => {
    listarCategoria();
  }, [current]);

  useEffect(() => {
    listarCategoria();
  }, [filtro]);

  const obtenerListaValor = async () => {

    const data = await generalesProvider.obtenerLista();
    setLista(data);
    formFile.setFieldsValue({
      idlista: 0
    }); //seteamos el

  };

  useEffect(() => {
    obtenerListaValor();
  }, []);

  const btnEditarListaValor = (data) => {

    setTitleListaValor('Actualizar Listar Valor');
    formModalListarValor.setFieldsValue({
      id: data.id,
      nombre: data.nombre,
      listaId: data.listaid
    }); //seteamos el
    setIsModalListarValorVisible(true);
  };
  const btnEliminarListaValor = (data) => {
    Modal.confirm({
      title: 'GESSOMA',
      content: 'Esta seguro que desea eliminar registro.',
      okText: 'Ok',
      cancelText: 'Cancelar',
      onCancel: () => {
      },
      onOk: async () => {

        const res: any = await generalesProvider.eliminar_listavalor({ id: data.id });
        if (res.succeeded) {
          message.success(res.message);
          listarCategoria();
        }
      }
    });
  };
  const onChangeListar = (data) => {

    if (data === 0) {
      Modal.warning({
        title: 'Mensaje de advertencia',
        content: 'Seleccione otra lista...'
      });
    } else {
      setfiltro({ listaId: data });
    }
  };

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 8
      }
    },
    wrapperCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 16
      }
    }
  };

  const IsModalCrearListaValorCancel = useCallback(() => {
    //setListdefaultValueCompartidoCon([]);
    formModalListarValor.resetFields();
    setIsModalListarValorVisible(false);
  }, [formModalListarValor]);

  const onSubmitModalCrearListaValorOk = useCallback(async (values) => {
    /*Obtenedemos el objeto generado en el arbol */


    var request = {
      Id: parseInt(values.getFieldValue('id')),
      Nombre: values.getFieldValue('nombre'),
      listaId: parseInt(values.getFieldValue('listaId'))
    };
    const res: any = await generalesProvider.registrar_actualizar_listavalor(request);
    if (res.succeeded) {
      message.success(res.message);
      setfiltro({ listaId: parseInt(values.getFieldValue('listaId')) });
      //await listarCategoria();
    }
    formModalListarValor.resetFields();
    setIsModalListarValorVisible(false);
  }, []);
  const btnAgregarListaValor = () => {

    if (filtro.listaId === 0) {
      Modal.warning({
        title: 'Mensaje de advertencia',
        content: 'Para agregar se necesita que seleccione lista...'
      });
    } else {
      setTitleListaValor('Registrar Listar Valor');
      formModalListarValor.setFieldsValue({
        id: 0,
        nombre: '',
        listaId: filtro.listaId
      }); //seteamos el
      setIsModalListarValorVisible(true);
    }


    //
    // if (data === 0) {
    //     Modal.warning({
    //         title: 'Mensaje de advertencia',
    //         content: 'Seleccione otra lista...',
    //     });
    // } else {
    //     setfiltro({ listaId: data });
    // }
  };
  return (
    <>
      <Card title={'Administración de Lista Valores'}>
        <div className='row'>
          <div className='col-md-4'>
            <div className='row'>
              <div className='col-md-12'>
                <Form {...formItemLayout}
                      form={formFile}
                      onFinish={() => onSubmitCrearFileOk(formFile)} name='register'
                      scrollToFirstError>
                  <Form.Item name='idlista' label='Lista.'
                    // rules={[{ required: true, message: 'Lista es requerido!' }]}
                  >
                    <Select onChange={onChangeListar}>
                      <Option key={0} value={0}>--Seleccione--</Option>
                      {
                        lista.map((p, index) => {
                          return (
                            <Option key={index} value={p.id}>{p.nombre}</Option>
                          );
                        })
                      }
                    </Select>
                  </Form.Item>
                  <Form.Item label='id' name='id' noStyle>
                    <Input type='hidden' />
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
          <Divider type='vertical' style={{ height: 'auto' }} />
          <div className='col-md-7'>
            <div className='row'>
              <div className='col-md-12'>
                <Row justify={'end'}>
                  <Col>
                    <Form.Item>
                      <Space size={'middle'}>
                        <Button type='primary' block onClick={btnAgregarListaValor}>
                          Agregar
                        </Button>
                      </Space>
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <Table locale={{ emptyText: 'No existen registros' }} pagination={false} columns={columns}
                       dataSource={data.data}
                       bordered />
                <Row justify={'center'}>
                  <Col>
                    <PaginacionPersonalizada total={data.totalRecords} current={current} onChange={setCurrent} />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Card>

      <Modal title={titleListaValor}
             visible={isModalListarValorVisible}
             onOk={formModalListarValor.submit}
             onCancel={IsModalCrearListaValorCancel}
             okText='Guardar'
             cancelText='Cancelar'
      >
        <div className='row'>
          <div className='col-md-12'>
            <Form
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              form={formModalListarValor}
              onFinish={() => onSubmitModalCrearListaValorOk(formModalListarValor)}
              autoComplete='off'>
              <Form.Item
                label='Nombre'
                name='nombre'
                rules={[{ required: true, message: 'Nombre es requerido!' }]}>
                <Input />
              </Form.Item>
              <Form.Item label='id' name='id' noStyle>
                <Input type='hidden' />
              </Form.Item>
              <Form.Item label='listaId' name='listaId' noStyle>
                <Input type='hidden' />
              </Form.Item>
            </Form>
          </div>
        </div>
      </Modal>

    </>
  );
};
export default AdministracionListaValores;